/*
 * SPDX-FileCopyrightText: 2022 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule } from '@spartacus/core';
import {
  ActiveFacetsModule,
  CardModule, FormErrorsModule, GlobalMessageComponentModule,
  IconModule,
  MediaModule,
  OutletModule,
  OutletRefModule,
  PageLayoutModule,
  PageSlotModule,
  ProgressButtonModule
} from '@spartacus/storefront';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { CheckoutOrderListModule } from './checkout-order-list/checkout-order-list.module';
import { OrderReviewModule } from './order-review/order-review.module';

@NgModule({
  imports: [
    CommonModule,
    PageLayoutModule,
    OutletModule,
    OutletRefModule,
    PageSlotModule,
    FormsModule,
    ReactiveFormsModule,
    FormErrorsModule,
    ActiveFacetsModule,
    IconModule,
    I18nModule,
    UrlModule,
    RouterModule,
    MediaModule,
    CardModule,
    ProgressButtonModule,
    OrderReviewModule,
    GlobalMessageComponentModule,
    CheckoutOrderListModule,
    BsDatepickerModule.forRoot(),
  ],
  declarations: [],
  exports: [],

  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class CheckoutModule { }
